module.exports = __webpack_public_path__ + "14four/static/media/FlickIcon.f88da4aa.svg";